/**
 * Created by fworld on 2019/12/26.
 */
import  {Client} from './mqttws31'
let MqttClient = {
    client: null,
    getNode: () => {
        console.log('please modify Promise')
        return new Promise()
    },
    connect: ({host, port, clientId, userName, password, keepalive, isSsl}) => {
        console.log("enter connect")
        MqttClient.client = new Client(host, port, '/mqtt', clientId)
        MqttClient.client.onConnectionLost = MqttClient.failure
        MqttClient.client.onFailure = MqttClient.failure
        MqttClient.client.onMessageArrived = MqttClient.messageArrived
        MqttClient.client.connect({
            userName: userName,
            password: password,
            timeout: 10,
            keepAliveInterval: keepalive,
            cleanSession: true,
            useSSL: isSsl,
            onSuccess: MqttClient.messageConnect
        })
    },
    random: (min, max) => {
        return Math.random().toFixed(3) * (max - min) + min;
    },
    failure: (min = 1000, max = 5000) => {
        setTimeout(MqttClient.messageConnectionLost, MqttClient.random(min, max))
    },
    messageConnect: () => {

    },
    messageLost: () => {
    },

    messageArrived: (message) => {
        console.log('please modify messageArrived')
    },
    messageConnectionLost: function () {
        let _this = MqttClient
        _this.messageLost()
        MqttClient.client = null
        _this.getNode().then(res => {
            let data = res.data
            let info = data.ipPort.split(`:`)
            data.host = info[0]
            data.port = parseInt(info[1], 10)
            _this.connect(data)
        }).catch(() => {
            _this.failure(8000, 30000)
        })
    },
    disconnect: () => {
        if (MqttClient.client !== null) {
            MqttClient.client.disconnect()
        }

    }
}

export default MqttClient
